module.exports = __webpack_public_path__ + "static/media/croque-monsieur.3dc3cddb.jpg";